import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Products, ProductsState } from "../../types/types";

export const getProducts = createAsyncThunk<Products[], void>(
  "Products/getProducts",
  async () => {
    const API_URL = process.env.REACT_APP_URL_BACKEND;

    if (!API_URL) throw new Error("REACT_APP_URL_BACKEND is not defined");

    const response = await fetch(`${API_URL}/api/v1/products/`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const products: Products[] = await response.json();

    return products;
  }
);

const initialState: ProductsState = {
  productsArr: [],
  loading: false,
  error: null,
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.productsArr = action.payload;
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default productsSlice.reducer;

